__turbopack_context__.v({
  "blok-big-title": "TagsContainer-module__jxcnva__blok-big-title",
  "blok-subtitle": "TagsContainer-module__jxcnva__blok-subtitle",
  "blok-title": "TagsContainer-module__jxcnva__blok-title",
  "tags-container": "TagsContainer-module__jxcnva__tags-container",
});
